import { ICourse } from '../../../interfaces/ICourse'
import { Typography } from '@mui/material'
import React from 'react'
import VideoStreamPlayer from '../../VideoStreamPlayer/VideoStreamPlayer'
import { getNextCardImageSrc } from '@/components/ExtraStyleLogic/cardImages'

export default function CourseDetailsActionComponentMedia(props: {
  courseDetails: ICourse
}) {
  const [videoUrl] = React.useState(
    props.courseDetails?.video_stream_data?.[0]?.stream_url ||
      props.courseDetails?.video_ads_url,
  )
  const [backgroundImage, setBackgroundImage] = React.useState<string>('')

  React.useEffect(() => {
    setBackgroundImage(getNextCardImageSrc())
  }, [])

  if (videoUrl) {
    return (
      <div>
        <VideoStreamPlayer
          poster={props?.courseDetails?.video_stream_data?.[0]?.poster}
          media_url={videoUrl}
          hideControls={false}
          videoStyle={{
            maxHeight: '200px',
            backgroundColor: 'black',
            borderRadius: 'none',
          }}
          // school_details={this.props.school_details}
        />
      </div>
    )
  }

  return (
    <div>
      {props.courseDetails.background_image ? (
        <div
          style={{
            height: '200px',
            backgroundImage: `url('${props.courseDetails.background_image}')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      ) : (
        <div
          style={{
            height: '200px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImage:backgroundImage,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography style={{ color: '#fff', fontSize: '30px' }}>
            {/* {course.name.charAt(0) + course.name.charAt(1)} */}
          </Typography>
        </div>
      )}
    </div>
  )
}
